var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'with-sidebar': _vm.isSidebarPresent },attrs:{"id":"sd-beta-testing-banner"}},[_vm._v("\n    Beta Testing\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }